import { BARE_NUMBER_UOM_RE, canonicalUnit, readUnitNotation } from "../../utils/unitVocabulary";

/** The Pack Unit cell's pre-commit check on the vendor invoice review grid. */
export function validatePackUnit(value: any): string | null {
  const v = String(value ?? "").trim();
  if (!v) return null;
  if (canonicalUnit(v)) return null;
  // MC-4: a pack notation ("CS10PK", "10PK/CS", "6BT/CTN", "2DOZ") commits, raw,
  // so the grid's red cell can say what it states from the vocabulary's one
  // reader. Refusing it here hid that reason for every typed value (Chrome
  // retest, 16 Sep); extraction never passed through this check.
  const read = readUnitNotation(v);
  if (read?.unit && read.packCount) return null;
  // A bare number is a count, not a size (USC-BUG-0026).
  if (BARE_NUMBER_UOM_RE.test(v)) {
    return `"${v}" is a count, not a pack unit — enter ${v} in Units / Case and CASE, BOX, BAG or PCS here`;
  }
  // Deliberately permissive about words: a supplier may sell by some unit the
  // vocabulary has not met yet, and the grid flags it in red either way. Only
  // the shapes that are certainly not a pack unit are refused.
  if (/\d/.test(v)) return `"${v}" looks like a size, not a pack unit — try CASE, BOX, BAG or PCS`;
  if (v.length < 2) return `"${v}" is not a pack unit — try CASE, BOX, BAG or PCS`;
  return null;
}
